import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import BookingModule from "@/store/modules/booking";
import { computed, defineComponent, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import NotificationService from "@/services/notification.service";
import { LogLevel, LogService } from "@/services/logging";
import editPen from "@/assets/images/svg/edit-pen-rectangle.svg";
import roundCheckIcon from "@/assets/images/svg/green-round-check.svg";
import { Currencies } from "@/constants/currency";
import { AccountingState, PaymentMethods, PromocodeCampaignType } from "@/types/db/accounting";
import { sumArray } from "@/utils/helpers/common";
import ScannerModule from "@/store/modules/scanner";
import { extractCodeFromUrl, getPromocodeInputPlaceholder, getPromocodePaymentType, processPromocode, removeCodePayment } from "@/utils/vue-helpers/promocode";
import { getSumOfCodeGeneratedAccountingsValues } from "@/utils/vue-helpers/new-accountings";
export default defineComponent({
  name: "Promocode",
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var editPenIconStyle = "width: 30px; height: 30px";
    var editPenIconContent = editPen;
    var editPenIconAlt = "Edit";
    var roundCheckIconStyle = "width: 32px; height: 32px; margin-right: 10px";
    var roundCheckIconContent = roundCheckIcon;
    var roundCheckIconAlt = "Check";
    var promocode = ref(getExistingPromocode()
    /*BookingModule.appliedPromocode*/
    );
    var isLoading = ref(false);
    var displaySuccessMsg = computed(function () {
      // We return true if the code is applied successfully
      // the code is applied successfully if it has generated accountings
      if (getSumOfCodeGeneratedAccountingsValues(promocode.value) > 0) {
        return true;
      } else {
        return false;
      }
    });
    var isPromocodeApplied = computed(function () {
      return BookingModule.isPromocodeApplied;
    });
    var isPromocodeLengthValid = computed(function () {
      return promocode.value.length >= 5;
    });
    var appliedCodesStats = computed(function () {
      var stats = [];
      var booking = BookingModule.selectedBooking;
      var codePendingAccountings = booking.accountings.filter(function (acc) {
        return acc.state === AccountingState.Pending && !acc.refund && !acc.id
        /*not coming from backend*/
        && (acc.promocode || acc.promoCodeUuid || acc.promoCodeId);
      });

      if (codePendingAccountings && codePendingAccountings.length) {
        (function () {
          var codes = _toConsumableArray(new Set(codePendingAccountings.map(function (acc) {
            return acc.promocode || acc.promoCodeUuid;
          }))); // console.log("applied codes");
          // console.log(codes);


          var _loop = function _loop(i) {
            var accEntriesValues = codePendingAccountings.filter(function (acc) {
              return acc.promocode === codes[i] || acc.promoCodeUuid === codes[i];
            }).map(function (acc) {
              return acc.accountingEntriesList;
            }).flat().map(function (ae) {
              return ae.value;
            });
            var sum = sumArray(accEntriesValues); // TODO POS: Rewrite this

            var remain = getPromocodeRemainingValue(String(codes[i])) + getPromocodeOldDiscountValues();
            stats.push({
              code: String(codes[i]),
              ttlDiscountOrPayment: sum,
              remaining: remain
            });
          };

          for (var i = 0; i < codes.length; i++) {
            _loop(i);
          }
        })();
      }

      return stats;
    });
    var currency = computed(function () {
      var _BookingModule$select;

      return ((_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.currency) || Currencies.CHF;
    });
    var newLogicCodeResult = computed(function () {
      var _BookingModule$select2;

      // Here we return the pending accountings values related to this applied code that were recently created when user applied the code
      var createdAccountings = (_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.accountings.filter(function (acc) {
        return acc.state === AccountingState.Pending && !acc.refund && (acc.promocode === promocode.value || acc.promoCodeUuid === promocode.value);
      });

      if (createdAccountings && createdAccountings.length) {
        return sumArray(createdAccountings.map(function (acc) {
          return acc.accountingEntriesList;
        }).flat().map(function (ae) {
          return ae.value;
        }));
      }

      return 0; // const appliedCode = BookingModule.appliedPromocodes.find((code) => code.promocode.code === promocode.value);
      // if (!appliedCode) return 0;
      // return sumArray(getPromocodePaymentValue(BookingModule.selectedBooking?.pssList || [], appliedCode).map((it) => it.promocodeDiscountValue));
    });
    var newLogicCodeResultText = computed(function () {
      return currency.value + " " + (newLogicCodeResult.value / 100).toFixed(2);
    });
    var promocodeRemainingAmount = computed(function () {
      return "".concat(currency.value, " ").concat(((getPromocodeRemainingValue() + getPromocodeOldDiscountValues()) / 100).toFixed(2));
    });

    function getPromocodeRemainingValue(code) {
      var _BookingModule$select3;

      var dt1 = new Date();
      var appCode = promocode.value;

      if (code) {
        appCode = code;
      }

      if (!promocode.value) {
        return 0;
      }

      var currentPromocode = BookingModule.appliedPromocodes.find(function (p) {
        return p.promocode.code === appCode;
      });

      if (!currentPromocode) {
        return 0;
      }

      var flatValue = 0;
      var pendingValue = 0;

      if (currentPromocode) {
        flatValue = currentPromocode.promocode.flatValue;
        pendingValue = Number(currentPromocode.promocode.pendingValue);
      }

      var codeResult = 0; // Payment code result is the sum of accEntries recently generated by this code

      var codeAccountings = (_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.accountings.filter(function (acc) {
        return (acc.promocode === appCode || acc.promoCodeUuid === appCode) && !acc.refund;
      });

      if (codeAccountings && codeAccountings.length) {
        // so we have accountings generated by this code
        // lets exclude that ones that are already synched in backend and are already included in promocode pending value
        var originalBooking = BookingModule.synchedBookings[BookingModule.selectedBookingUUID];
        var oldCodeAccountingsUuid = [];

        if (originalBooking) {
          var _BookingModule$select4;

          // So we're in an Edit order
          // lets get old accountings generated by this code
          var oldCodeAccountings = (_BookingModule$select4 = BookingModule.selectedBooking) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.accountings.filter(function (acc) {
            return acc.promocode === appCode || acc.promoCodeUuid === appCode;
          });

          if (oldCodeAccountings && oldCodeAccountings.length) {
            oldCodeAccountingsUuid = oldCodeAccountings.map(function (acc) {
              return String(acc.uuid);
            });
          }
        }

        if (oldCodeAccountingsUuid && oldCodeAccountingsUuid.length) {
          // lets exclude old accountings from codeAccountings array
          codeAccountings = codeAccountings.filter(function (acc) {
            return !oldCodeAccountingsUuid.includes(String(acc.uuid));
          });
        }

        codeResult = sumArray(codeAccountings.map(function (acc) {
          return acc.accountingEntriesList;
        }).flat().map(function (ae) {
          return ae.value;
        }));
      }

      var amountAvailable = flatValue - pendingValue - codeResult;
      return amountAvailable;
    }

    var paymentType = ref(PaymentMethods.POS_PROMO_CODE);
    var successMessage = ref("");
    var inputPlaceholder = computed(function () {
      return getPromocodeInputPlaceholder(paymentType.value);
    });
    var appliedPromocodeType = computed(function () {
      var _BookingModule$applie;

      return (_BookingModule$applie = BookingModule.appliedPromocode) === null || _BookingModule$applie === void 0 ? void 0 : _BookingModule$applie.promocode.promoCodeType;
    });

    function updatePaymentType(type) {
      paymentType.value = type;
    }

    function setSuccessMessage(promocodeType) {
      switch (promocodeType) {
        case PromocodeCampaignType.TYPE_PROMO_CODE:
          successMessage.value = t("promocode.promo-code-applied");
          break;

        case PromocodeCampaignType.TYPE_GIFT_CARD_SOLD:
          successMessage.value = t("promocode.gift-card-applied");
          break;

        case PromocodeCampaignType.TYPE_VOUCHER_SOLD:
          successMessage.value = t("promocode.voucher-applied");
          break;

        case PromocodeCampaignType.TYPE_MEMBERSHIP_SOLD:
          successMessage.value = t("promocode.membership-applied");
      }
    }

    var isEditOrder = computed(function () {
      return BookingModule.isEditOrderBooking;
    });

    if (isPromocodeApplied.value && appliedPromocodeType.value) {
      setSuccessMessage(appliedPromocodeType.value);
    }

    var scanPromocodeModal = ref(false);
    var ScannerTog = computed(function () {
      return ScannerModule.tog;
    });
    watch(ScannerTog, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var scannedValue, isUrl, code, scannedJsonCode;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(ScannerModule.value && scanPromocodeModal.value)) {
                _context.next = 40;
                break;
              }

              LogService.info("Promocode: scanner triggered, value = ".concat(ScannerModule.value)); // The scanned valued can be a json object (Locarno logic) and can be a url (old logic for everyone else)
              // Check if the voucherCode is a URL

              scannedValue = ScannerModule.value;
              isUrl = String(scannedValue).startsWith("http://") || String(scannedValue).startsWith("https://") || String(scannedValue).startsWith("http//") || String(scannedValue).startsWith("https//");

              if (!isUrl) {
                _context.next = 18;
                break;
              }

              LogService.info("Promocode: scanned value is in url format");
              console.log("Promocode: scanned value is in url format"); // We keep the old logic of extracting the code from the url scanned

              code = extractCodeFromUrl(ScannerModule.value);
              LogService.info("Promocode: extracted from qrcode string code: ".concat(code));

              if (!(code && code.length >= 5)) {
                _context.next = 16;
                break;
              }

              promocode.value = code;
              LogService.info("Promocode: going to process scanned promocode: ".concat(promocode.value));
              _context.next = 14;
              return applyPromocode();

            case 14:
              LogService.info("Promocode: Done processing scanned promocode: ".concat(promocode.value));
              scanPromocodeModal.value = false;

            case 16:
              _context.next = 40;
              break;

            case 18:
              LogService.info("Promocode: scanned value is not in url format. Checking if it is json object."); // Check if the scanned value is actually a json object

              _context.prev = 19;
              scannedJsonCode = JSON.parse(scannedValue);
              LogService.info("Promocode: scanned value is in json format attached.", {
                params: scannedJsonCode
              }); // Check if it's in the expected format

              if (!(scannedJsonCode && scannedJsonCode.code && scannedJsonCode.token)) {
                _context.next = 32;
                break;
              }

              LogService.info("Promocode: scanned value is exactly in the expected format.", {
                params: scannedJsonCode
              }); // Lets proceed applying the code

              promocode.value = scannedJsonCode.code;
              LogService.info("Promocode: going to process scanned promocode: ".concat(promocode.value));
              _context.next = 28;
              return applyPromocode();

            case 28:
              LogService.info("Promocode: Done processing scanned promocode: ".concat(promocode.value));
              scanPromocodeModal.value = false;
              _context.next = 34;
              break;

            case 32:
              LogService.info("Promocode: scanned value is not in the expected format.", {
                params: scannedJsonCode
              }); // Lets notify the user that code couldn't be scanned

              NotificationService.showCustomMessage(t("promocode.could-not-scan"), "error");

            case 34:
              _context.next = 40;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context["catch"](19);
              // Couldn't parse the scanned value into a json object, this means the scanned value isn't a url and isn't a json obj, lets log
              LogService.info("Promocode Error: scanned value is neither a url nor a valid json object: ".concat(promocode.value), {
                param: {
                  scannedValue: scannedValue,
                  err: _context.t0
                }
              }, LogLevel.Error); // Lets notify the user that code couldn't be scanned

              NotificationService.showCustomMessage(t("promocode.could-not-scan"), "error");

            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[19, 36]]);
    })), {
      deep: true
    });
    /**
     * This function return the last used promocode if there are any
     */

    function getExistingPromocode() {
      var _BookingModule$select5;

      if (!BookingModule.isEditOrderBooking) return ""; // if the booking has a promocode accounting, then we get the code  showing

      var accountings = ((_BookingModule$select5 = BookingModule.selectedBooking) === null || _BookingModule$select5 === void 0 ? void 0 : _BookingModule$select5.accountings) || [];
      var code = "";

      for (var i = 0; i < accountings.length; i++) {
        if ((accountings[i].promoCodeId || accountings[i].promoCodeUuid) && accountings[i].state === AccountingState.Completed && accountings[i].refund !== 1 && accountings[i].promocode) {
          code = accountings[i].promocode || "";
        }
      }

      return code;
    }
    /**
     * this function returns the promocode discount value of the original pulled booking
     */


    function getPromocodeOldDiscountValues() {
      var originalPulledBooking = BookingModule.synchedBookings[BookingModule.selectedBookingUUID];

      if (!BookingModule.isEditOrderBooking || !originalPulledBooking) {
        return 0;
      }

      var oldPromocodeAccountingEntries = originalPulledBooking.booking.accountings.filter(function (acc) {
        return acc.promoCodeId && acc.state === AccountingState.Completed && acc.refund !== 1;
      }).map(function (acc) {
        return acc.accountingEntriesList;
      }).flat();
      return sumArray(oldPromocodeAccountingEntries.map(function (ae) {
        return ae.value;
      }));
    }

    function applyPromocode() {
      return _applyPromocode.apply(this, arguments);
    }

    function _applyPromocode() {
      _applyPromocode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var appliedCode, promocodePaymentType;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!isLoading.value) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                isLoading.value = true;
                _context2.next = 5;
                return processPromocode(promocode.value);

              case 5:
                // check if the promocode was applied
                appliedCode = BookingModule.appliedPromocodes.find(function (p) {
                  return p.promocode.code === promocode.value;
                });

                if (appliedCode) {
                  // the promocode was succesfully applied
                  // let's update the payment type UI
                  promocodePaymentType = getPromocodePaymentType(appliedCode.promocode.promoCodeType);

                  if (promocodePaymentType) {
                    paymentType.value = promocodePaymentType;
                  }
                }

                isLoading.value = false;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _applyPromocode.apply(this, arguments);
    }

    return {
      displaySuccessMsg: displaySuccessMsg,
      isPromocodeApplied: isPromocodeApplied,
      promocode: promocode,
      isLoading: isLoading,
      editPenIconStyle: editPenIconStyle,
      editPenIconContent: editPenIconContent,
      editPenIconAlt: editPenIconAlt,
      isPromocodeLengthValid: isPromocodeLengthValid,
      roundCheckIconStyle: roundCheckIconStyle,
      roundCheckIconAlt: roundCheckIconAlt,
      roundCheckIconContent: roundCheckIconContent,
      // promocodeDiscountValues,
      // promocodeDiscountResultText,
      promocodeRemainingAmount: promocodeRemainingAmount,
      // pssSumPromocodeDiscountValues,
      t: t,
      paymentType: paymentType,
      successMessage: successMessage,
      updatePaymentType: updatePaymentType,
      PaymentMethods: PaymentMethods,
      appliedPromocodeType: appliedPromocodeType,
      inputPlaceholder: inputPlaceholder,
      setSuccessMessage: setSuccessMessage,
      isEditOrder: isEditOrder,
      scanPromocodeModal: scanPromocodeModal,
      newLogicCodeResultText: newLogicCodeResultText,
      appliedCodesStats: appliedCodesStats,
      currency: currency,
      applyPromocode: applyPromocode,
      removeCodePayment: removeCodePayment
    };
  },
  methods: {
    openScanPromocodeModal: function openScanPromocodeModal() {
      this.scanPromocodeModal = true;
    }
  }
});